'use client'

import { styled } from 'styled-components'

export const StyledHotelWithPriceAndTermSlide = styled.div<{ $orientation: string; $position: string }>`
    position: relative;
    height: 100dvh;
    aspect-ratio: ${props => props.$orientation == "horizontal" ? "16/9" : "9/16"};
    
    margin-inline: auto;
    padding-inline: 1rem;
    box-sizing: border-box;

    * {
        z-index: 2;
        position: relative;
    }

    img {
        z-index: 1;
    }

    ${({ $orientation, $position }) => $orientation == "horizontal" ? `
        margin-inline: 0;
        padding-left: 2.4rem;

        >div {
            width: 50%;
            margin-left: ${$position == 'left' ? "0" : "auto"};
        }
    ` : ''}
`

export const StyledH1 = styled.h1<{ $color: string; $shade?: string; $orientation: string }>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    padding-top: 2rem;
    font-size: 1.8rem;
    ${({ $orientation }) => $orientation == "horizontal" ? `
        padding-top: 2rem;
        font-size: 2.6rem;
        padding-top: 1rem;
    ` : ''}
`

export const StyledH2 = styled.h2<{ $color: string; $shade?: string; $position: string; $orientation: string}>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    display: inline-block;
    background-color: #e40227;
    margin-left: -1rem;
    margin-bottom: 1rem;
    padding: 0.2rem 1rem;
    position: relative;
    font-size: 2.0rem;

    ${({ $orientation, $position, $shade }) => $orientation == "horizontal" ? `
        font-size: 3.6rem;
        margin-left: ${$position == 'left' ? "-2.4rem" : "0"};
        padding: 0.8rem 2.4rem;
        margin-bottom: 1.4rem;
        ${$shade ? `text-shadow: ${$shade} 2px 2px;` : ""}
    `: ''}

    &:after {
        width: calc(100% - 1rem);
        bottom: -4px;
        height: 4px;

        ${({ $orientation, $position }) => $orientation == "horizontal" ? `
            width: ${$position == 'left' ? "calc(100% - 2.4rem)" : "100%"};
            margin-left: ${$position == 'left' ? "0" : "-2.4rem"};
            bottom: -0.4rem;
            height: 0.4rem;
        `: ''}

        display: block;
        content: "";
        background-color: white;
        z-index: 1;
        position: absolute;
    }
`

export const StyledRow = styled.div<{ $orientation: string }>`
    display: grid;
    grid-column: -1 / 1;
    grid-template-columns: subgrid;
    align-items: center;

    >div {
        align-items: center;
        display: flex;
        justify-content: space-between;
    }

    background-color: rgba(255, 255, 255, 0.4);
    margin-bottom: 1rem;
    padding: 0.4rem 0.5rem;
    border-radius: 5px;

    ${({ $orientation }) => $orientation == "horizontal" ? `
        margin-bottom: 1.2rem;
    `: ''}
`

export const DestinationRowDestination = styled.span<{ $color: string; $shade?: string; $orientation: string }>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    font-size: 0.8rem;
    line-height: 1.1rem;

    ${({ $orientation }) => $orientation == "horizontal" ? `
        font-size: 1.3rem;
        line-height: 2rem;
    `: ''}
`

export const DestinationRowPrice = styled.span<{ $color: string; $shade?: string; $orientation: string }>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    font-size: 1rem;
    line-height: 1.1rem;
    font-weight: 700;
    text-align: right;

    ${({ $orientation }) => $orientation == "horizontal" ? `
        font-size: 1.5rem;
        line-height: 1.6rem;
    `: ''}
`

export const PlaneDiv = styled.div`
    position: relative;
    height: 1.5rem;
    aspect-ratio: 9 / 6;
`

